import useDebounce from '@root/core/hooks/useDebounce';
import useTranslate from '@root/core/hooks/useTranslate';
import BreadcrumbList from '@root/modules/Sellers/Stock/components/Breadcrumb';
import { formatDateTime } from '@root/utils/helpers/formatDate';
import React, { useEffect, useState } from 'react';
import { stateKorea } from '../../utils/Languages';
import FilterAction from '../components/filterAction';
import LogisticsCenterList from '../components/LogisticsCenterList';
import LogisticsCenterTable from '../components/LogisticsCenterTable';
import settlement from '../services/settlement';


const stateBox = [
  {
    title: '선택',
    value: ''
  },
  {
    title: '결제요청전',
    value: 'New'
  },
  {
    title: '결제전',
    value: 'Request'
  },
  {
    title: '결제완료',
    value: 'Completed'
  }
];
const filterBox = [
  {
    title: '선택',
    value: ''
  },
  {
    title: '물류센터명',
    value: 'name'
  },
  {
    title: '영수증번호',
    value: 'receiptId'
  },
  {
    title: '판매자이름',
    value: 'sellerName'
  },
];

const WarehouseSettlement = () => {
  const [t] = useTranslate();
  const [rowData, setRowData] = useState();
  const [total, setTotal] = useState(0);
  const [selectedRow, setSelectedRow] = useState<React.Key[]>([]);
  const [loading, setLoading] = useState(false);
  const [filterDate, setFilterDate] = useState<[string, string]>();
  const fromDt: string = (filterDate && filterDate[0]) || '';
  const toDt: string = (filterDate && filterDate[1]) || '';
  const [filterState, setFilterState] = useState('');
  const [filter, setFilter] = useState('');
  const [filterInput, setFilterInput] = useState('');
  const debounce = useDebounce(filterInput, 1000);
  const [page, setPage] = useState(1);
  const [sort, setSort] = useState(false);
  const breadcrumbList = [
    {
      tittle: '정산 관리',
      url: '/admin/busk/settlement'
    },
    {
      tittle: '물류센터 정산 조회',
      url: ''
    }
  ];
  const getLogisticsCenterList = async (
    page: number,
    fromDt: string,
    toDt: string,
    state: string,
    filter: string,
    filterInput: string,
    sort: boolean
  ) => {
    setLoading(true);
    const settlementList = await settlement.getLogisticsCenterList(
      page,
      fromDt,
      toDt,
      state,
      filter,
      filterInput,
      sort
    );
    const rowDataModified : any = settlementList?.data?.map(
      (r: any, index: number) => {
        return {
          ...r,
          key: r.id,
          updatedAt: formatDateTime(r.updatedAt),
          state: stateKorea(r.state)
        };
      }
    ) ?? [];
    setRowData(rowDataModified);
    setTotal(settlementList?.count);
    setLoading(false);
  };

  const handleStateValue = (value: string) => {
    setFilterState(value);
  };
  const handleFilterValue = (value: string) => {
    setFilter(value);
  };
  const handleInputValue = (value: string) => {
    setFilterInput(value);
  };
  const handleDateValue = (value: [string, string]) => {
    setFilterDate(value);
  };
  const onchangeSort = () => {
    setSort(!sort);
  };
  const handleChangePage = (page: number) => {
    setPage(page);
  };

  useEffect(() => {
    getLogisticsCenterList(page, fromDt, toDt, filterState, filter, debounce, sort);
  }, [page]);

  useEffect(() => {
    if (page === 1) {
      getLogisticsCenterList(page, fromDt, toDt, filterState, filter, debounce, sort);
    } else {
      setPage(1);
    }
  }, [fromDt, toDt, filterState, debounce, sort]);

  return (
    <div>
      <BreadcrumbList listBreadcrumb={breadcrumbList} />
      <div className="busk-container">
        <FilterAction
          stateBox={stateBox}
          filterBox={filterBox}
          handleDateValue={handleDateValue}
          handleStateValue={handleStateValue}
          handleFilterValue={handleFilterValue}
          handleInputValue={handleInputValue}
        />
        <LogisticsCenterList
          rowData={rowData}
          count={total}
          selectedRow={selectedRow}
          page={page}
          fromDt={fromDt}
          toDt={toDt}
          filterState={filterState}
          filter={filter}
          filterInput={filterInput}
          sort={sort}
        />
        <LogisticsCenterTable
          rowData={rowData}
          sort={sort}
          setSort={onchangeSort}
          total={total}
          selectedRow={selectedRow}
          setSelectedRow={setSelectedRow}
          loading={loading}
          handleChangePage={handleChangePage}
          page={page}
        />
      </div>
    </div>
  );
};

export default WarehouseSettlement;
